<template>
  <main-content>
    <b-card>
      <ERegistrationHeaderFormInfo />
      <ERegistrationOwnerRegisterForm v-if="iamsmartSession==null" :invitation-key="invitationKey" :businessId="businessId"/>
      <ERegistrationOwnerRegisterIAmSmartForm v-else :invitation-key="invitationKey" :businessId="businessId" :iamsmart-session="iamsmartSession"/>
    </b-card>
  </main-content>
</template>

<script>
import ERegistrationOwnerRegisterForm from "../components/e-registration-owner-register/ERegistrationOwnerRegisterForm";
import ERegistrationOwnerRegisterIAmSmartForm from "../components/e-registration-owner-register/ERegistrationOwnerRegisterIAmSmartForm";
import ERegistrationHeaderFormInfo from "../components/e-registration-header-form/ERegistrationHeaderFormInfo"
import { IAmSmartQrCodeApi } from '@/api';

export default {
  props: {
    invitationKey: {
      type: String
    },
    businessId:{
      type: String
    }
  },
  components: {
    ERegistrationHeaderFormInfo,
    ERegistrationOwnerRegisterIAmSmartForm,
    ERegistrationOwnerRegisterForm
  },
  async beforeRouteEnter(to, _from, next) {
    const { businessId } = to.params;
    const iamsmartSession = (await IAmSmartQrCodeApi.getSession(businessId)).data;

    if (businessId) {
      next((vm) => {
        vm.iamsmartSession = iamsmartSession;
      });
    } else {
      next();
    }
  },
  data() {
    return {
      iamsmartSession: null
    }
  }
};
</script>

<style lang="scss" scoped></style>
